export interface FakeReviewAuthorAddDto {
    Username: string;
    AvatarUrl: string | null;
}

export interface FakeReviewCommentAddDto {
    Text: string;
    Tags: string[];
    MinRating: number;
    MaxRating: number;
}

export interface GameReview {
    Id: string;
    RealmId: string;
    UserId: string;
    GameId: string;
    Rating: number;
    Comment: string;
    CreatedAt: string;
    IsFake: boolean;
}

export interface RatingCounts {
    Rating1: number;
    Rating2: number;
    Rating3: number;
    Rating4: number;
    Rating5: number;
}

export interface RatingStat {
    FakeCount: number;
    RealCount: number;
}

export interface RatingStats {
    Rating1: RatingStat;
    Rating2: RatingStat;
    Rating3: RatingStat;
    Rating4: RatingStat;
    Rating5: RatingStat;
}

export interface FakeReviewAuthor {
    Id: string;
    Username: string;
    AvatarUrl: string | null;
    IsActive: boolean;
}

export interface FakeReviewComment {
    Id: string;
    Text: string;
    Tags: string[];
    MinRating: number;
    MaxRating: number;
}

export enum GameReviewKindFilter {
    Unknown = 0,
    All = 1,
    FakeOnly = 2,
    RealOnly = 3,
}

export enum RemoveStrategy {
    Unknown = 0,
    NewestFirst = 1,
    OldestFirst = 2,
    Random = 3,
}
